import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TaskNoneIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M5.42 19.84V4.08H10.26C10.44 3.28 11.14 2.68 12 2.68C12.86 2.68 13.56 3.28 13.74 4.08H18.58V19.84H5.42ZM7.26 18H16.74V5.72H14.94V6.92H9.06V5.72H7.26V18Z" />
    </SvgIcon>
  );
});
